<template>
  <v-toolbar
    :app="!overContent"
    :absolute="overContent"
    flat
    class="app-toolbar elevation-4"
    :color="color"
  >
    <v-btn icon v-if="back" @click="handleBack('/')">
      <v-icon color="primary">fas fa-arrow-left</v-icon>
    </v-btn>
    <app-drawer-toggle-button v-else color="primary" />
    <router-link to="/" class="ml-3" style="text-decoration: none">
      <v-toolbar-title class="headline"> {{ toolbar.title }} </v-toolbar-title>
    </router-link>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn
        icon
        v-if="toolbar.search && !showSearchBar"
        @click="
          showSearchBar = true;
          $nextTick(() => $refs.query.focus());
        "
      >
        <v-icon color="primary">fas fa-search</v-icon>
      </v-btn>
      <v-text-field
        ref="query"
        v-if="toolbar.search && showSearchBar"
        v-model="query"
        label="Search"
        prepend-icon="fas fa-search"
        append-icon="fas fa-eraser"
        @click:append="query = ''"
      />
      <v-btn icon to="/recipes-filter" v-if="toolbar.filter">
        <v-badge v-if="tags.length" color="accent">
          <span slot="badge">{{ tags.length }}</span>
          <v-icon color="primary"> fas fa-filter </v-icon>
        </v-badge>
        <v-icon v-else color="primary"> fas fa-filter </v-icon>
      </v-btn>
      <v-menu transition="slide-y-transition" bottom v-if="toolbar.menu">
        <v-btn slot="activator" icon>
          <v-icon color="primary">fas fa-ellipsis-v</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, index) in toolbar.menu"
            :key="index"
            @click="item.action"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import AppDrawerToggleButton from "@/components/AppDrawerToggleButton";
import { SET_QUERY } from "@/action-types";
import handleBackMixin from "@/mixins/handleBackMixin";
export default {
  name: "AppToolbar",
  components: { AppDrawerToggleButton },
  mixins: [handleBackMixin],
  data() {
    return {
      showSearchBar: false
    };
  },
  computed: {
    toolbar() {
      return this.$store.state.toolbar;
    },
    tags() {
      return this.$store.state.filter.tags;
    },
    filterActive() {
      return this.tags && this.tags.length > 0;
    },
    overContent() {
      return this.toolbar.overContent;
    },
    color() {
      return this.toolbar.color || "white";
    },
    back() {
      return this.toolbar.back || false;
    },
    query: {
      get() {
        return this.$store.state.filter.query;
      },
      set(query) {
        this.$store.commit(SET_QUERY, query);
      }
    }
  }
};
</script>
